import Fetch from './fetch';
const fetch = new Fetch();

function fetchTBSAdvConf(appid, adv_type, adv_target=6) {
    return new Promise((resolve, reject) => {
        fetch.get(`extfe/getX5AdvConfByProductId?appid=${appid}&adv_type=${adv_type}&adv_target=${adv_target}`)
            .then(resp => {
                if (resp.ret === 0) {
                    resolve(resp.data);
                } else {
                    reject(resp)
                }
            })
            .catch(e => {
                console.log("fetchTBSAdvConf失败", e);
                reject(e)
            });
    })
}

export {fetchTBSAdvConf};